<div
  #popover
  [attr.aria-labelledby]="ariaLabelledBy"
  [attr.role]="role"
  [id]="id"
  popover
  [style.top.px]="top"
  [style.left.px]="left"
  (toggle)="handlePopupToggle($event)"
>
  <ng-container *ngIf="isOpen">
    <ng-content></ng-content>
  </ng-container>
</div>
